import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useRoute, useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var params = route.params,
      query = route.query;
    var path = params.path;
    router.replace({
      path: '/' + path,
      query: query
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div");
    };
  }
});